import React from "react";
import { useRoadMap } from "@/hooks/useRoadMap";

export default function RoadmapSection() {
  const roadMap = useRoadMap();

  return (
    <>
    <div className="xl:container mt-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 xl:gap-y-0 gap-y-8 xl:grid-cols-4">
        {roadMap.map((item, index) => (
          <div
            key={index}
            className={`border-2 border-[#3a3a3c] p-4 2xl:p-8 rounded-lg text-center shadow-sm shadow-[#3a3a3c]`}
          >
            {/* 
            <div className="text-zinc-900 dark:text-white text-lg font-semibold mb-2">
              {item.id}
            </div>
            */}

            <div className="dark:text-white text-xl 2xl:text-2xl font-bold mb-8 gothamBlack text-left">
              {new Date(item.year).getFullYear() + (item.quarter ? ` - ${item.quarter}` : "")}
            </div>

            <div className="flex flex-col items-start">
              {item.items.map((subItem, subIndex) => (
                <div key={subIndex} className={`flex flex-row items-center ${subIndex !== item.items.length - 1 ? "mb-4" : ""}`}>
                  <div>
                    <input type="checkbox" className="mr-4" onChange={(e) => {}} checked={subItem.complete} onClick={(e) => e.preventDefault()} />
                  </div>
                  <div className="text-metaxseed-text-gray text-sm text-left gothamBook !leading-relaxed">
                    {subItem.item}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  );
}
